module.exports = __webpack_public_path__ + "static/img/point.03a5ea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/point.png
// module id = 9Jbz
// module chunks = 0